import originData from '../../originsData.json';

export function getOrigin(origin) {
  const origins = process.env.REACT_APP_CUSTOM_NODE_ENV == 'production' ? originData.prd : originData.homolog;
  return origins[origin.toLowerCase()];
}

export function exists(origin) {
  return !!getOrigin(origin);
}